import service from "../../../services/purchase/supplierContact"

export default {
    namespaced: true,
    actions: {
        create(context, payload) {
            return new Promise((resolve, reject) => {
                service.create(payload).then(response => {
                    resolve(response)
                }).catch(error => {
                    reject(error)
                })
            })
        },
        update(context, payload) {
            return new Promise((resolve, reject) => {
                service.update(payload).then(response => {
                    resolve(response)
                }).catch(error => {
                    reject(error)
                })
            })
        },
        findByID(context, payload) {
            return new Promise((resolve, reject) => {
                service.findByID(payload).then(response => {
                    resolve(response)
                }).catch(error => {
                    reject(error)
                })
            })
        },
        remove(context, payload) {
            return new Promise((resolve, reject) => {
                service.remove(payload).then(response => {
                    resolve(response)
                }).catch(error => {
                    reject(error)
                })
            })
        }
    }
}
